var g = Object.defineProperty;
var h = (a, t, r) => t in a ? g(a, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : a[t] = r;
var A = (a, t, r) => h(a, typeof t != "symbol" ? t + "" : t, r);
import n from "dayjs";
import D from "./chunk373.js";
import S from "./chunk374.js";
import x from "./chunk375.js";
import M from "./chunk376.js";
import F from "./chunk377.js";
import O from "./chunk378.js";
import j from "./chunk379.js";
import B from "./chunk380.js";
import { isString as b } from "./chunk312.js";
import { parseToNumber as y } from "./chunk334.js";
n.extend(D);
n.extend(S);
n.extend(F);
n.extend(x);
n.extend(M);
n.extend(O);
n.extend(B);
n.locale(j);
const o = class o {
  static get dayjs() {
    return n;
  }
  static toDayJs(t, r, e) {
    return b(e, !0) ? n.tz(t, r ?? "", e) : n(t, r);
  }
  static toDayJsInUTC(t, r) {
    return o.dayjs.utc(t, r);
  }
  static cloneDayJsObject(t) {
    return t.clone();
  }
  static getTimestamp() {
    return n(/* @__PURE__ */ new Date()).millisecond().valueOf();
  }
  static isSameOrBefore(t, r, e) {
    return t.isSameOrBefore(r, e);
  }
  static isSameOrAfter(t, r, e) {
    return t.isSameOrAfter(r, e);
  }
  static isBetween(t, r, e, i, s) {
    return e.isBetween(t, r, i, s);
  }
  static isAfter(t, r, e) {
    return t.isAfter(r, e);
  }
  static isBefore(t, r, e) {
    return t.isBefore(r, e);
  }
  static sortDescFunc(t, r, e) {
    return r.diff(t, e);
  }
  static sortAscFunc(t, r, e) {
    return t.diff(r, e);
  }
  static sortDates(t, r, e) {
    return Array.isArray(t) ? r === "asc" ? t.sort((i, s) => o.sortAscFunc(i, s, e)) : t.sort((i, s) => o.sortDescFunc(i, s, e)) : [];
  }
  static convertTo24Hours(t, r = !0) {
    var d, l, p;
    const e = (d = t.match(/^(\d+)/)) == null ? void 0 : d[1], i = (l = t.match(/:(\d+)/)) == null ? void 0 : l[1];
    let s = e ? Number(e) : 0;
    const c = i ? Number(i) : 0, m = (p = t.match(/\s(.*)$/)) == null ? void 0 : p[1];
    m == "PM" && s < 12 && (s = s + 12), m == "AM" && s == 12 && (s = s - 12);
    let u = s.toString(), f = c.toString();
    return r && (s < 10 && (u = `0${u}`), c < 10 && (f = `0${f}`)), `${u}:${f}`;
  }
  static addTimeToDate(t, r) {
    try {
      if (t.isValid()) {
        const e = r && /\b(1[0-2]|0?[1-9]):([0-5][0-9])( [AaPp][Mm])?/.test(r) ? r : "12:00:00 AM", s = (/\s(.*)$/.test(e) ? o.convertTo24Hours(e) : e).split(":"), c = y(s[0]), m = y(s[1]);
        return t.set("hour", c).set("minute", m).set("second", 0).set("millisecond", 0);
      }
      return t.clone();
    } catch (e) {
      return console.error(e), t.clone();
    }
  }
  static parseTimeStringToObject(t) {
    const r = o.convertTo24Hours(t.toUpperCase(), !1).split(":");
    return {
      hours: r[0],
      minutes: r[1]
    };
  }
  static validateDate(t) {
    return o.dayjs(t).isValid();
  }
  static isInappropriateAge(t) {
    const r = o.toDayJs(t, "DD.MM.YYYY"), e = o.dayjs(), i = o.sortDescFunc(r, e, "year");
    return i < 11 || i > 18;
  }
  static getExpiresDateForCookie(t, r) {
    return o.dayjs().add(t, r).toString();
  }
};
A(o, "dateTimeToMinutes", (t) => {
  try {
    const r = t.split(":"), e = (+r[0] * (6e4 * 60) + +r[1] * 6e4 + +r[2] * 1e3) / 6e4;
    if (isNaN(e))
      throw new Error("Invalid dateTime format! DateTime should be in format 00:00:00");
    return Math.ceil(e);
  } catch (r) {
    return console.error(r), 0;
  }
});
let T = o;
export {
  T as DateHelper
};
